/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import MyPublications from "layouts/my-publications";
import EditPublication from "layouts/my-publications/EditPublication";
import MyOrders from "layouts/my-orders";
import Tables from "layouts/tables";
import PublishHere from "layouts/publish-here";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import AccountConnections from "layouts/account/connections";
import TrayCallback from "layouts/tray-callback";
import Admin from "layouts/admin";
import ContractPage from "layouts/contract";
import VerifyAccount from "layouts/verify-account";

// @mui icons
import Icon from "@mui/material/Icon";

const routes = [
  {
    type: "hidden",
    name: "Verificar conta",
    key: "verify-account",
    route: "/verificar-conta",
    component: <VerifyAccount />,
  },
  {
    type: "collapse",
    name: "Contrato",
    key: "contract",
    icon: <Icon fontSize="small">description</Icon>,
    route: "/contrato",
    component: <ContractPage />,
  },
  {
    type: "hidden",
    name: "Editar publicação",
    key: "edit-publication",
    route: "/my-publications/:id/edit",
    component: <EditPublication />,
  },
  {
    type: "collapse",
    name: "Administração",
    key: "admin",
    adminOnly: true,
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    route: "/admin",
    component: <Admin />,
  },
  {
    type: "collapse",
    name: "Painel",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Minhas Publicações",
    key: "my-publications",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/my-publications",
    component: <MyPublications />,
  },
  {
    type: "collapse",
    name: "Meus Pedidos",
    key: "my-orders",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/my-orders",
    component: <MyOrders />,
  },
  {
    type: "collapse",
    name: "Calculadora",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/calculator",
    component: <Tables />,
  },
  {
    type: "collapse",
    name: "Publique Aqui",
    key: "billing",
    icon: <Icon fontSize="small">menu_book</Icon>,
    route: "/publish-here",
    component: <PublishHere />,
  },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <SignIn />,
  },
  {
    type: "hidden",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/signup",
    component: <SignUp />,
  },
  {
    type: "hidden",
    name: "Conexoes da Conta",
    key: "account-connections",
    icon: <Icon fontSize="small">link</Icon>,
    route: "/account",
    component: <AccountConnections />,
  },
  {
    type: "hidden",
    name: "Retorno da conexão",
    key: "tray-callback",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/tray/callback",
    component: <TrayCallback />,
  },
  {
    type: "hidden",
    name: "Retorno da autorização",
    key: "tray-auth-callback",
    icon: <Icon fontSize="small">store</Icon>,
    route: "/tray/callback/auth",
    component: <TrayCallback />,
  },
];

export default routes;
